import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { ReportService } from '../../../../services/reports/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseAddorEditEmployeeComponent } from './components/add-employee/add-employee.component';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { JobTitleService } from '../../../../services/jobtitle/jobtitle.service';
import { JobTitle } from '../../../../models/jobtitle/jobtitle';
import { AddEmployeeDto } from '../../../../models/employee/add-employee-dto';
import { EmployeeExcelConfigurationComponent } from './components/employee-excel-configuration/employee-excel-configuration.component';
import { EmployeeMailConfigurationComponent } from './components/employee-mail-configuration/employee-mail-configuration.component';
import { EmployeeDatabase } from './employeeDatabase';
import { EmployeeDataSource } from './employeeDataSource';
import { TeacherAttendanceSheetConfigurationComponent } from './components/teacher-attendance-sheet-configuration/teacher-attendance-sheet-configuration.component';
import { environment } from '../../../../../../environments/environment';
// import { IndexCardConfigurationComponent } from 'app/main/content/pages/management/configurations/index-card-configuration/index-card-configuration.component';
import { EmployeeIndexCardConfigurationComponent } from './components/employee-index-card-configuration/employee-index-card-configuration.component';
import { EmployeeScheduleDialogComponent } from './components/employee-schedule-dialog/employee-schedule-dialog.component';
import { SubjectScheduleDialogComponent } from './components/subject-schedule-dialog/subject-schedule-dialog.component';

@Component({
    selector: 'fuse-management-employees',
    templateUrl: './employees.component.html',
    styleUrls: ['./employees.component.scss'],
    animations: fuseAnimations
})
export class EmployeesComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['LastName', 'FirstName', 'DocumentNumber', 'Actions'];
    employeetDatabase: EmployeeDatabase;
    dataSource: EmployeeDataSource | null;
    confirmDialogRef: any;
    selectedJobTitleId: number;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    public jobTitles: JobTitle[];
    public jobTitleSelected = -1;
    private sub: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private employeeService: EmployeeService,
        public jobTitleService: JobTitleService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        this.sub = this.route.params.subscribe(params => {
        });
        this.jobTitleService.getAll().subscribe(response => {
            this.blockUI.stop();
            this.jobTitles = response.slice();
            if (this.jobTitles.find(e => e.Id === -1) === undefined) {
                const todos = new JobTitle();
                todos.Id = -1;
                todos.Description = 'Todos';
                this.jobTitles.unshift(todos);
            }
            console.log('StudentsComponent > ngOnInit > this.jobTitleService.jobTitles', this.jobTitleService.jobTitles);
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        this.employeetDatabase = new EmployeeDatabase(this.employeeService);
        this.dataSource = new EmployeeDataSource(this.employeetDatabase, this.paginator, this.sort, this.jobTitleSelected);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        this.blockUI.stop();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    add() {
        const employee = new AddEmployeeDto();

        const config: MatDialogConfig = {
            // height: '75%',
            width: '90vw',
            maxWidth: '90vw',
            maxHeight: '80%',
            height: '80%',
            disableClose: true,
            data: {
                mode: 'new',
                employee: JSON.parse(JSON.stringify(employee))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddorEditEmployeeComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result !== true) {
                this.employeetDatabase.add(result);
            }
        });
    }

    editOrView(mode: string, employee: any) {
        console.log(employee.LastName);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '80%',
            disableClose: true,
            data: {
                mode: mode,
                employee: JSON.parse(JSON.stringify(employee))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddorEditEmployeeComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
            console.log('mode', mode);
            if (result !== true) {
                if (mode === 'edit') {
                    this.employeetDatabase.edit(result);
                }
            }
        });
    }

    delete(student: any) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', student.LastName + ' ' + student.FirstName, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.employeeService.delete(student.Id).subscribe(response => {
                    if (response.ResultCode === 1) {
                        this.employeetDatabase.delete(student);
                        const index = this.employeeService.employees.findIndex(s => s.Id === student.Id);
                        if (index >= 0) {
                            this.employeeService.employees.splice(index, 1);
                            delete this.employeeService.employeesObject[student.Id];
                        }
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res1: string) => {
                            this.sweetAlertService.error('Error', res1, null);
                        });
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res2: string) => {
                        this.sweetAlertService.error('Error', res2, null);
                    });
                });
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }

    gotoMedicalLetters(employee: IStudent) {
        this.router.navigate(['pages/management/medicalletters/' + employee.Id]);
    }

    filterStaffByJobTitle(_jobTitleId: number) {
        this.dataSource.filterByJobTitle(_jobTitleId);
        this.selectedJobTitleId = _jobTitleId;
    }

    attendance() {
        const config: MatDialogConfig = {
            width: '600px',
            maxWidth: '600px',
            disableClose: true,
            data: {}
        };

        this.confirmDialogRef = this.dialog.open(TeacherAttendanceSheetConfigurationComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result !== true) {
                this.employeetDatabase.add(result);
            }
        });
    }

    exportEmployeesToExcel() {

        const config: MatDialogConfig = {
            width: '90vw',
            maxWidth: '90vw',
            maxHeight: '80%',
            height: '80%',
            disableClose: true,
            data: {}
        };

        this.confirmDialogRef = this.dialog.open(EmployeeExcelConfigurationComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {

        });
    }

    exportMailEmployeesToClipboard() {

        const config: MatDialogConfig = {
            width: '50%',
            height: '80%',
            disableClose: true,
            data: {}
        };

        this.confirmDialogRef = this.dialog.open(EmployeeMailConfigurationComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {

        });
    }

    printIndexCard(row) {
        window.open(environment.backendUri + 'report/indexcard/' + row.Id, '_new');
    }

    openScheduleDialog(row): void {
        this.dialog.open(EmployeeScheduleDialogComponent, {
            data: {
                row: row
            }
        });
    }

    openSubjectScheduleDialog(): void {
        const config: MatDialogConfig = {
            width: '900px',
            maxWidth: '1000px',
            disableClose: true,
            data: {}
        };
        this.dialog.open(SubjectScheduleDialogComponent, config);
    }

    // indexCardConfig() {
    //     const config: MatDialogConfig = {
    //         width: '1200px',
    //         maxWidth: '1200px',
    //         disableClose: true,
    //         data: {}
    //     };
    //
    //     this.confirmDialogRef = this.dialog.open(IndexCardConfigurationComponent, config);
    //     this.confirmDialogRef.afterClosed().subscribe(result => {
    //
    //     });
    // }

    printIndexCards() {
        const config: MatDialogConfig = {
            width: '60vw',
            maxWidth: '60vw',
            maxHeight: '80%',
            height: '80%',
            disableClose: true,
            data: {}
        };

        this.confirmDialogRef = this.dialog.open(EmployeeIndexCardConfigurationComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
        });
    }

    refreshData() {
        this.blockUI.start('Cargando...');
        this.employeetDatabase.refresh(() => {
            this.blockUI.stop();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/employees.component.ts